import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getLightningScenariosAPI() {
  const url = `${AWS_API_URL}/lighting/scenarios`;

  return getRequest(url, await authorize());
}
